/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SecurityTypeDialog extends SiteEntityDialog<SecurityTypeRow, any> {
        protected getFormKey() { return SecurityTypeForm.formKey; }
        protected getIdProperty() { return SecurityTypeRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityTypeRow.localTextPrefix; }
        protected getNameProperty() { return SecurityTypeRow.nameProperty; }
        protected getService() { return SecurityTypeService.baseUrl; }

        protected form = new SecurityTypeForm(this.idPrefix);

    }
}